
export function setUserInfo(info) {

    return {
        type: 'userInfo',
        payload: info
    }
}